/**
 * Скролл-шоукейс ПК на главной (02_GPT-MODULAR).
 * Обёртка + хук. SVG слайдов — в PcSlide1/2/3/4 и PcLatestWorks.
 */

import { useRef } from "react";
import usePcScrollShowcase from "../../hooks/usePcScrollShowcase";
import PcSlide1 from "./PcSlide1";
import PcSlide2 from "./PcSlide2";
import PcSlide3 from "./PcSlide3";
import PcSlide4 from "./PcSlide4";
import PcLatestWorks from "./PcLatestWorks";
import "./PcScrollShowcase.css";

function PcScrollShowcase({ onSendEmail }) {
    const pcTrackRef = useRef(null);
    const pcStickyRef = useRef(null);
    const pc1Ref = useRef(null);
    const pc2Ref = useRef(null);
    const pc3Ref = useRef(null);
    const pc4Ref = useRef(null);
    const latestWorksRef = useRef(null);

    usePcScrollShowcase({
        trackRef: pcTrackRef,
        stickyRef: pcStickyRef,
        pc1Ref,
        pc2Ref,
        pc3Ref,
        pc4Ref,
        latestWorksRef,
    });

    return (
        <>
{/* Group 73 - Illustration Section */}
<div ref={pcTrackRef} className="pc-scroll-track">
<div ref={pcStickyRef} className="pc-scroll-sticky">
<div className="pc-scroll-stage">
<PcSlide1 ref={pc1Ref} onSendEmail={onSendEmail} />
<PcSlide2 ref={pc2Ref} />
<PcSlide3 ref={pc3Ref} />
<PcSlide4 ref={pc4Ref} />
<PcLatestWorks ref={latestWorksRef} onSendEmail={onSendEmail} />
</div>
</div>
</div>
        </>
    );
}

export default PcScrollShowcase;
// components/PcScrollShowcase/PcScrollShowcase.js
